import { render, staticRenderFns } from "./InputLinkButton.vue?vue&type=template&id=3d8d3648&scoped=true&"
import script from "./InputLinkButton.vue?vue&type=script&lang=js&"
export * from "./InputLinkButton.vue?vue&type=script&lang=js&"
import style0 from "./InputLinkButton.vue?vue&type=style&index=0&id=3d8d3648&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8d3648",
  null
  
)

export default component.exports